/**
 * Canicule : comparateur usage chips (keyboard accessible, no column reorder)
 */
(function () {
  'use strict';

  var USAGE_MAP = {
    brume: 1,
    metro: 2,
    compact: 2,
    bureau: 3
  };

  function initComparison(root) {
    if (root.dataset.caniculeComparisonInit === 'true') return;
    root.dataset.caniculeComparisonInit = 'true';

    var chips = root.querySelectorAll('[data-comparison-usage]');
    var table = root.querySelector('.canicule-comparison__table');
    if (!chips.length || !table) return;

    var activeChip = null;

    function clearHighlight() {
      table.querySelectorAll('.canicule-comparison__table--highlight').forEach(function (cell) {
        cell.classList.remove('canicule-comparison__table--highlight');
      });
    }

    function highlightColumn(colIndex) {
      clearHighlight();
      var rows = table.querySelectorAll('tr');
      rows.forEach(function (row) {
        var cell = row.children[colIndex];
        if (cell) cell.classList.add('canicule-comparison__table--highlight');
      });
      root.setAttribute('data-comparison-active', String(colIndex));
    }

    function setChip(chip, on) {
      chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      chip.classList.toggle('is-active', on);
    }

    function activateChip(chip) {
      var usage = chip.getAttribute('data-comparison-usage');
      var colIndex = USAGE_MAP[usage];
      if (!colIndex) return;

      if (activeChip === chip) {
        setChip(chip, false);
        activeChip = null;
        clearHighlight();
        root.removeAttribute('data-comparison-active');
        return;
      }

      chips.forEach(function (c) {
        setChip(c, c === chip);
      });
      activeChip = chip;
      highlightColumn(colIndex);
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        activateChip(chip);
      });
      chip.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activateChip(chip);
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-canicule-comparison-interactive]').forEach(initComparison);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-canicule-comparison-interactive]').forEach(initComparison);
  });
})();
